import { errorToast } from "@/v2-ui/toast"
import FeatureConfigurationEditor from "@/v2-backoffice-client/feature/configuration/FeatureConfigurationEditor"
import { getNavLayerEditorModelPath } from "@/v2-backoffice-client/navlayer/update/navlayer.update.schema"
import { useNavLayerUpdateMutation } from "@/v2-backoffice-client/navlayer/update/navlayer.update.mutation"
import type { NavLayerFragment } from "@/v2-backoffice-client/navlayer/__types__/navlayer.fragment"

export type NavLayerUpdateEditorProps = {
  className?: string
  navLayer: NavLayerFragment | null | undefined
}

/**
 * The runtime-catalog binding of the shared configuration editor: saves
 * against the nav layer's common.Features row, and the normalized cache
 * updates the table and the sheet from the mutation response.
 */
function NavLayerUpdateEditor(props: NavLayerUpdateEditorProps) {
  const { navLayer, className } = props

  const [updateNavLayer, { loading, error }] = useNavLayerUpdateMutation()
  errorToast(error, { title: "Failed to update nav layer" })

  if (!navLayer) return null

  return (
    <FeatureConfigurationEditor
      className={className}
      modelPath={getNavLayerEditorModelPath()}
      value={JSON.stringify(navLayer.Configuration, null, 2)}
      isSaving={loading}
      onSave={(configuration) => {
        void updateNavLayer({
          variables: {
            input: {
              FeatureCode: navLayer.FeatureCode,
              Configuration: configuration,
            },
          },
        })
      }}
    />
  )
}

export default NavLayerUpdateEditor
